module.exports = __webpack_public_path__ + "img/chi.ea8c1699.svg";